export default __webpack_public_path__ + "static/media/pizza.38465bd1.svg";